import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { settingsActions } from '../../actions';
import { ActionLogsActionPayload } from '../../typedefs';

export function* actionLogs({
  payload,
}: PayloadAction<ActionLogsActionPayload>) {
  try {
    yield effects.put(settingsActions.startFetching());
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.post, [
      { endpoint: 'subscriptions/payment-fe-action-logs/', body },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(settingsActions.stopFetching());
  }
}
